// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './units/rem';

import axios from 'axios'
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'


Vue.use(ElementUI);
import Meta from 'vue-meta'
Vue.use(Meta, Viewer)
Vue.use(Viewer)

Vue.config.productionTip = false
Vue.prototype.$axios = axios


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  data: {
    keywords: "",
    description: "",
    title: "",
    viewId: 1
  },
  created() {
    this.getSEO();
    // 全局配置
    router.beforeEach((to, from, next) => {
      // Change doc title
      if (to.meta.title == '逸旁科技') {
        this.viewId = 1;
      } else if (to.meta.title == '逸旁科技') {
        this.viewId = 2;
      }
      console.log(this.viewId);
      this.getSEO(this.viewId);
      next();
    })
  },
  methods: {
    //获取seo
    getSEO(viewId) {
      this.$axios.post("https://gw.x-embers.com/api/index/seo", {
        "view_id": this.viewId
      }).then((response) => {
        let res = response.data;
        // console.log(res.data);
        if (res.status == 1) {
          this.keywords = res.data.key_words;
          this.description = res.data.description;
          this.title = res.data.title;
          document.title = this.title || '逸旁科技';
          document.title = to.meta.title || '斗麦科技'
          document.querySelector('meta[name="Keywords"]').setAttribute('content', this.keywords)
          document.querySelector('meta[name="Description"]').setAttribute('content', this.description)
        } else {
          this.$layer.msg(res.message);
        }
      }).catch((err) => {
        console.log(err);
      })
    }
  },
})



// WEBPACK FOOTER //
// ./src/main.js